// Example project data for Quick Fill feature
// Contains 3 variations of complete project data

const EXAMPLE_PROJECTS = [
    {
        customerData: {
            company: {
                id: '',
                name: 'EDP Brasil',
                sector: 'Energia'
            },
            focalPoint: 'Maria Silva',
            focalPointPosition: 'Gerente de Novos Negócios',
            focalPointEmail: 'maria.silva@edpbrasil.com.br',
            businessDescritive: 'Empresa de energia com atuação nacional, líder em soluções sustentáveis. Atua nos mercados de geração distribuída compartilhada (GDC), mercado livre de energia, e serviços de eficiência energética. Principais produtos incluem: sistemas fotovoltaicos, gestão de consumo energético, e consultoria em transição energética.'
        },
        projectData: {
            title: 'Pesquisa de Mercado - Expansão GDC',
            type: 'Pesquisa e experimentação com consumidor',
            startDate: '2024-03-15',
            endDate: '2024-07-30',
            goal: 'Conduzir pesquisa de mercado para identificar oportunidades de expansão no segmento de GDC, entendendo as principais barreiras de entrada e expectativas dos consumidores residenciais e comerciais que ainda não adotaram energia solar.',
            businessContext: 'O setor de energia está passando por transformação digital com crescente interesse em energia renovável. A empresa já possui presença sólida em grandes clientes, mas enfrenta dificuldades para atingir público residencial e pequenas empresas. O desafio é entender como comunicar valor e facilitar a adoção de GDC neste segmento.',
            targetPublic: 'Proprietários de residências com telhado adequado para instalação solar (classe B2C) e pequenas empresas (comercial) que buscam reduzir custos operacionais. Foco em consumidores conscientes ambientalmente e interessados em sustentabilidade.'
        },
        impact: {
            expectedResults: 'Aumentar a taxa de conversão de leads em 25%, reduzir o tempo de ciclo de vendas em 30%, e expandir market share no segmento residencial. Espera-se também melhorar o NPS através de estratégias de comunicação mais adequadas.',
            impactedBusinessIndicators: ['CAC', 'Taxa de conversão', 'NPS', 'Market Share', 'Ciclo de vendas'],
            deliverables: ['Jornada AS IS', 'Perfis de Consumidor', 'Benchmark de Comunicação', 'Direcionamentos Estratégicos', 'Cardápio de Ideias']
        }
    },
    {
        customerData: {
            company: {
                id: '',
                name: 'Banco Internacional',
                sector: 'Financeiro'
            },
            focalPoint: 'João Santos',
            focalPointPosition: 'Diretor de Transformação Digital',
            focalPointEmail: 'joao.santos@bancointernacional.com.br',
            businessDescritive: 'Instituição financeira líder no mercado latino-americano, com mais de 100 anos de atuação. Oferece soluções bancárias para pessoas físicas e jurídicas, investimentos, seguros, e serviços de crédito. Principais produtos incluem: contas digitais, cartões de crédito, empréstimos consignados, e aplicações financeiras.'
        },
        projectData: {
            title: 'Design de Experiência - App Mobile',
            type: 'Produtos e experiências digitais',
            startDate: '2024-04-01',
            endDate: '2024-08-31',
            goal: 'Redesenhar a experiência do aplicativo mobile bancário para jovens de 18 a 35 anos, focando em usabilidade, educação financeira, e engajamento. Objetivo é aumentar a retenção de clientes neste segmento e expandir o uso de produtos digitais.',
            businessContext: 'O banco enfrenta concorrência crescente de fintechs que oferecem experiências digitais superiores. Clientes jovens têm expectativas diferentes sobre velocidade, transparência e facilidade de uso. O app atual possui taxonomia complexa e jornadas que não conversam com o público jovem.',
            targetPublic: 'Jovens de 18 a 35 anos, usuários de smartphones, que buscam facilidade e transparência em serviços financeiros. Inclui estudantes, profissionais liberais, e jovens executivos com renda entre 3K e 15K mensais.'
        },
        impact: {
            expectedResults: 'Aumentar o NPS de 35 para 55, reduzir taxa de churn em 20%, e aumentar o uso de produtos digitais em 40%. Espera-se também melhorar a percepção de modernidade e confiança da marca entre jovens.',
            impactedBusinessIndicators: ['NPS', 'Churn Rate', 'Engagement Digital', 'Retenção de Clientes', 'CAC'],
            deliverables: ['Análise Heurística', 'Jornadas AS IS', 'Jornada Ideal', 'Wireframes e Protótipos', 'Guia de Design System']
        }
    },
    {
        customerData: {
            company: {
                id: '',
                name: 'Construtora Nacional',
                sector: 'Construção Civil'
            },
            focalPoint: 'Ana Costa',
            focalPointPosition: 'Head de Inovação e Experiência',
            focalPointEmail: 'ana.costa@construtoranacional.com.br',
            businessDescritive: 'Empresa de construção civil com mais de 40 anos de atuação, especializada em empreendimentos residenciais de médio e alto padrão. Desenvolve condomínios verticais e horizontais com foco em sustentabilidade e qualidade. Principais produtos: apartamentos, casas em condomínio fechado, e torres comerciais.'
        },
        projectData: {
            title: 'Inovação em Jornada de Compra Imobiliária',
            type: 'Estratégia e futuro dos negócios',
            startDate: '2024-05-10',
            endDate: '2024-10-25',
            goal: 'Repensar completamente a jornada de compra de imóveis residenciais, incorporando tecnologia, transparência e agilidade. Foco em reduzir o tempo de decisão de compra e aumentar a conversão de leads em vendas efetivas através de experiência diferenciada.',
            businessContext: 'O mercado imobiliário está em transformação com adoção de tecnologias como realidade virtual, tours 3D, e processos digitais. A concorrência está oferecendo experiências mais ágeis e transparentes. O desafio é modernizar processos internos e criar jornadas que construam confiança desde o primeiro contato.',
            targetPublic: 'Compradores de imóveis residenciais de médio e alto padrão (R$ 500K a R$ 2M), com idade entre 30 e 50 anos. Inclui casais jovens procurando primeiro imóvel, famílias buscando mais espaço, e investidores interessados em imóveis para locação.'
        },
        impact: {
            expectedResults: 'Reduzir tempo médio de vendas de 90 para 45 dias, aumentar taxa de conversão de leads em 35%, e melhorar satisfação no pós-venda. Espera-se também aumentar a aquisição de clientes através de referências.',
            impactedBusinessIndicators: ['Taxa de Conversão', 'Ciclo de Vendas', 'NPS', 'CAC', 'Taxa de Referência'],
            deliverables: ['Jornadas AS IS', 'Jornada Ideal', 'Estratégia de Comunicação', 'Prototipação de Processos', 'Guia de Implementação']
        }
    }
];

/**
 * Gets a random example project from the predefined set
 * @returns {Object} A random example project with all required fields
 */
export const getRandomExampleProject = () => {
    const randomIndex = Math.floor(Math.random() * EXAMPLE_PROJECTS.length);
    return EXAMPLE_PROJECTS[randomIndex];
};

